import React, { FC } from "react";
import styled from "styled-components/macro";
import Module from "shared/lib/interfaces/Module";
import ModuleSection from "shared/lib/interfaces/ModuleSection";
import SlidePage, { SlidePageProgress, SlidePageProps } from "../../SlidePage";

interface Props {
  module: Pick<Module, "icon" | "name">;
  section: Pick<ModuleSection, "name">;
  progress: SlidePageProgress;
  onNext: SlidePageProps["onNext"];
  onBack: SlidePageProps["onBack"];
}

const ProactiveParentingHealthyFamilyRoutines1Slide: FC<Props> = (props) => {
  const { module, section, ...rest } = props;

  return (
    <SlidePage {...rest} title={module.name}>
      <section>
        <h3>FAMILY ROUTINES</h3>
        <p>
          Family routines are activities that your family does regularly during
          the day. Routines provide structure, support, and consistency for your
          child.
        </p>
      </section>
    </SlidePage>
  );
};

export default styled(ProactiveParentingHealthyFamilyRoutines1Slide)``;
